import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TokenStorage {

  /**
   * Get access token
   * @returns {Observable<string>}
   */
  public getAccessToken(): Observable<string> {
    const authorization: string = <string>localStorage.getItem('authorization');
    return of(authorization);
  }

  /**
   * Get refresh token
   * @returns {Observable<string>}
   */
  public getRefreshToken(): Observable<string> {
    const authorization: string = <string>localStorage.getItem('authorization');
    return of(authorization);
  }

  /**
   * Set access token
   * @returns {TokenStorage}
   */
  public setAccessToken(authorization: string): TokenStorage {
    localStorage.setItem('authorization', authorization);

    return this;
  }

   /**
   * Set refresh token
   * @returns {TokenStorage}
   */
  public setRefreshToken(authorization: string): TokenStorage {
    localStorage.setItem('authorization', authorization);

    return this;
  }

   /**
   * Remove tokens
   */
  public clear() {
    localStorage.removeItem('authorization');
  }
}
